import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalInterceptor } from '@azure/msal-angular';
import { AuthInterceptor } from './auth-interceptor';
import { MsInterceptor } from './ms.interceptor';

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: MsInterceptor,
        multi: true
    }
];
